/**
 * coachVerbs.ts — "click" on a mouse, "tap" on a touch screen.
 *
 * Editors write `{click}` / `{Click}` in a card; the card renders the word
 * that fits the device. One place decides, so the copy never has to say
 * "click or tap". Auto-start is desktop-only, but anyone can open the tour by
 * hand on a phone, and the words should still be right there.
 */

export function isTouchDevice(): boolean {
  try {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    // Coarse primary pointer = finger. Hover-capable devices with a mouse
    // report `fine`, tablets with a keyboard case still report coarse — fine,
    // "tap" is right for them too.
    return window.matchMedia('(pointer: coarse)').matches;
  } catch {
    return false;
  }
}

export const VERB_TOKENS: Record<string, { mouse: string; touch: string }> = {
  '{click}': { mouse: 'click', touch: 'tap' },
  '{Click}': { mouse: 'Click', touch: 'Tap' },
};

const TOKEN_RE = /\{[Cc]lick\}/g;

/** Replace every `{click}` / `{Click}` with the device's word. */
export function localizeVerbs(text: string, touch: boolean = isTouchDevice()): string {
  return text.replace(TOKEN_RE, (m) => {
    const entry = VERB_TOKENS[m];
    return entry ? (touch ? entry.touch : entry.mouse) : m;
  });
}
